import { useRef, useState } from "react";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import { api, imgSrc, fmtErr } from "@/lib/api";

export default function ImageField({ value, onChange, testid }) {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(fmtErr(err.response?.data?.detail));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div className="flex items-center gap-3">
      {value && <img src={imgSrc(value)} alt="preview" className="h-12 w-16 rounded-sm object-cover border border-brass/20" />}
      <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="Image URL or upload →" className="admin-input flex-1" data-testid={`${testid}-url-input`} />
      <button type="button" onClick={() => fileRef.current?.click()} disabled={busy} data-testid={`${testid}-upload-button`} className="flex items-center gap-2 rounded-sm border border-brass/30 px-3 py-2 text-xs text-brass hover:bg-brass/10 disabled:opacity-50 whitespace-nowrap">
        <Upload size={14} /> {busy ? "…" : "Upload"}
      </button>
      <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={upload} data-testid={`${testid}-file-input`} />
    </div>
  );
}
